export function getParams(patient_id, tab, payor) {
  return { patient_id, tab, payor }
}
